import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { APP_CONFIG } from '../config/app-config';
import { CurrentUserService } from './current-user.service';

/**
 * Blocks a deactivated (soft-disabled) user from the entire application shell, redirecting them to the
 * standalone "account deactivated" page. Bypassed when auth is disabled (local dev).
 */
export const accountActiveGuard: CanActivateFn = () => {
  const config = inject(APP_CONFIG);
  if (!config.authEnabled) {
    return true;
  }
  const current = inject(CurrentUserService);
  const router = inject(Router);
  return current
    .load()
    .pipe(map(() => (current.isActive() ? true : router.createUrlTree(['/account-disabled']))));
};
